import React from 'react';

import { NavBarV2 } from './nav-bar-v2';

export const NavBarWrapper = () => {
  return <NavBarV2 />;
};
